import JobFeeSource from '@/models/Jobs/JobFeeSource';
import JobType from '@/models/Jobs/JobType';
import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateJobGeneralDetailsRequest extends BaseUpdateRequest {
    ownerId: string;
    branchId: string;
    deskId: string;
    title: string;
    headcount: number;
    closingDate: string;
    desiredStartDate: string;
    annualSalaryMin: number;
    annualSalaryMax: number;
    purchaseOrderNumber = '';
    isTest = false;
    testEmailAddresses = '';
}